import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetValidationPausedReason,
	adminGetAllValidationPausedReasons,
	resetFocusValidationPausedReason,
	initNewValidationPausedReason,
	adminPatchValidationPausedReason,
	adminPostValidationPausedReason,
	adminDeleteValidationPausedReason,
} from 'services/validationPausedReason';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/ValidationPausedReasons/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	label: Yup.string().required('Champ requis'),
	order: Yup.number().required('Champ requis'),
});

class ValidationPausedReasonsAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusValidationPausedReason();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllValidationPausedReasons();
	};

	focusOnElement = (elt) => {
		this.props.adminGetValidationPausedReason(elt);
	};

	onAddClick = () => {
		this.props.initNewValidationPausedReason();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostValidationPausedReason(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchValidationPausedReason(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteValidationPausedReason(
			this.props.validationPausedReasons.focus.data
		);
	};

	render() {
		const { validationPausedReasons } = this.props;
		const { focus, list } = validationPausedReasons;
		const validationPausedReason = focus.data;
		const newValidationPausedReason =
			validationPausedReason !== null &&
			validationPausedReason.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={validationPausedReasons.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity='MOTIF DE PAUSE VALIDATION'
					addButtonText='Nouveau motif de pause validation'
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.label}
					groupField={false}
					focusedEltId={validationPausedReason}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity='Motif de pause validation'
					icon='info'
				>
					{validationPausedReason !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: validationPausedReason.id,
								label: validationPausedReason.label || '',
								order: validationPausedReason.order || 1,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusValidationPausedReason}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newValidationPausedReason ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newValidationPausedReason && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex',
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
	},
};

const mapStateToProps = (state) => {
	return {
		validationPausedReasons: state.admin.validationPausedReasons,
	};
};

const mapDispatchToProps = {
	adminGetAllValidationPausedReasons,
	adminGetValidationPausedReason,
	adminPatchValidationPausedReason,
	adminDeleteValidationPausedReason,
	resetFocusValidationPausedReason,
	adminPostValidationPausedReason,
	initNewValidationPausedReason,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ValidationPausedReasonsAdmin);
